/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * The role of the user

Values: 0=Respondent, 1=Owner, 2=Manager, 3=Viewer, 4=Admin, 5=Auditor
 * @export
 * @enum {number}
 */

export enum UserRole {
    Respondent = 0,
    Owner = 1,
    Manager = 2,
    Viewer = 3,
    Admin = 4,
    Auditor = 5
}


